// extracted by mini-css-extract-plugin
export default {"egypt_map":"Map_egypt_map__XElU6","selected_location":"Map_selected_location__WY0dZ"};